// Keep the startup fallback independent of providers, storage and locale bundles.
const startupMessages = {
  'zh-CN': ['页面启动失败', '请刷新页面重试。', '刷新页面'],
  'zh-TW': ['頁面啟動失敗', '請重新整理頁面後重試。', '重新整理頁面'],
  'en-US': ['Unable to start', 'Please reload and try again.', 'Reload'],
  'ja-JP': ['ページを起動できません', '再読み込みしてお試しください。', '再読み込み'],
  'pt-BR': [
    'Não foi possível iniciar',
    'Recarregue a página e tente novamente.',
    'Recarregar',
  ],
  'id-ID': ['Tidak dapat memulai', 'Muat ulang halaman dan coba lagi.', 'Muat ulang'],
  'fa-IR': ['راه‌اندازی ناموفق بود', 'صفحه را بازخوانی و دوباره تلاش کنید.', 'بازخوانی'],
  'bn-BD': ['চালু করা যায়নি', 'পৃষ্ঠা আবার লোড করে চেষ্টা করুন।', 'আবার লোড করুন'],
} as const;

export function getStartupMessages(locale: string) {
  const key =
    Object.keys(startupMessages).find(
      (key) => key.toLowerCase() === locale.toLowerCase(),
    ) ??
    Object.keys(startupMessages).find(
      (key) => key.split('-')[0] === locale.split('-')[0],
    );
  return startupMessages[(key ?? 'en-US') as keyof typeof startupMessages];
}
